import script from "./MmLatestMaterials.vue?vue&type=script&setup=true&lang=js"
export * from "./MmLatestMaterials.vue?vue&type=script&setup=true&lang=js"

import "./MmLatestMaterials.vue?vue&type=style&index=0&id=233ab010&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233ab010"]])

export default __exports__